module.exports = __webpack_public_path__ + "static/media/29DUNON6.bc12a678.jpg";